exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PostpaidBalance_container_2jEJ {}\n\n.PostpaidBalance_balance_28K- {\n  margin-bottom: 15px;\n\n  font-size: 21px;\n}\n\n.PostpaidBalance_invoices_2IXd {\n  margin-bottom: 20px;\n}\n\n.PostpaidBalance_row_3-fL {\n  margin-bottom: 5px;\n}\n\n.PostpaidBalance_label_1Ebf {\n  margin-right: 10px;\n\n  display: inline-block;\n\n  min-width: 100px;\n\n  color: #787878;\n}\n\n.PostpaidBalance_value_33SJ {\n  color: #282828;\n}\n\n.PostpaidBalance_overdueRow_3DTa .PostpaidBalance_label_1Ebf,\n.PostpaidBalance_overdueRow_3DTa .PostpaidBalance_value_33SJ {\n  color: #fc4a4a;\n}\n\n.PostpaidBalance_message_NNUA {\n  margin-bottom: 20px;\n}\n\n.PostpaidBalance_links_2ReY .PostpaidBalance_button_1Prd {\n  margin-right: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "PostpaidBalance_container_2jEJ",
	"balance": "PostpaidBalance_balance_28K-",
	"invoices": "PostpaidBalance_invoices_2IXd",
	"row": "PostpaidBalance_row_3-fL",
	"label": "PostpaidBalance_label_1Ebf",
	"value": "PostpaidBalance_value_33SJ",
	"overdueRow": "PostpaidBalance_overdueRow_3DTa",
	"message": "PostpaidBalance_message_NNUA",
	"links": "PostpaidBalance_links_2ReY",
	"button": "PostpaidBalance_button_1Prd"
};